<template>
  <div id="app">
    <el-container>
      <el-header>
        <div class="logo">
          <router-link to="/">
            <img src="./assets/img/toplogo.png" alt="益华通盛" />
          </router-link>
        </div>
        <el-menu
          :default-active="defaultActive"
          class="el-menu-demo"
          mode="horizontal"
          @select="handleSelect"
          :router="true"
        >
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/product">产品介绍</el-menu-item>
          <el-menu-item index="/case">产品列表</el-menu-item>
          <el-menu-item index="/news">云平台</el-menu-item>
          <el-menu-item index="/goin">走进益华通盛</el-menu-item>
          <el-menu-item index="/download">下载小程序</el-menu-item>
        </el-menu>
        <!-- 移动端菜单按钮 -->
        <div class="mobile-menu-btn" @click="mobileMenuVisible = !mobileMenuVisible">
          <i class="el-icon-s-operation"></i>
        </div>
      </el-header>

      <!-- 移动端菜单 -->
      <transition name="slide-down">
        <div v-show="mobileMenuVisible" class="mobile-menu">
          <div
            v-for="item in menuItems"
            :key="item.path"
            class="mobile-menu-item"
            :class="{ active: defaultActive === item.path }"
            @click="navigateTo(item.path)"
          >
            {{ item.label }}
          </div>
        </div>
      </transition>

      <el-main>
        <router-view />
      </el-main>
      <div class="footer" v-show="isShowFooter">
        <div class="footer-content">
          <ul class="content-nav">
            <li>
              <p>走进益华通盛</p>
              <router-link to="/goin">发展历程</router-link>
              <router-link to="/goin">企业文化</router-link>
              <router-link to="/goin">资质荣誉</router-link>
              <router-link to="/goin">合作伙伴</router-link>
            </li>
            <li>
              <p>云平台</p>
              <router-link to="/news">公司新闻</router-link>
              <router-link to="/news">行业动态</router-link>
            </li>
            <li>
              <p>产品中心</p>
              <router-link to="/product">介绍视频</router-link>
              <router-link to="/product">管理模式</router-link>
              <router-link to="/product">平台目标</router-link>
              <router-link to="/product">功能模块</router-link>
            </li>
            <li>
              <p>联系我们</p>
              <span>邮箱：ehuatech@163.com</span>
              <span>电话：0755-84872724</span>
              <span>地址：深圳市龙岗区龙城街道乐年广场 13 栋 A 座 1705</span>
            </li>
          </ul>
          <img src="./assets/img/carCode.png" alt="小程序码" />
          <img src="./assets/img/ercode.png" alt="公众号码" />
        </div>
        <div class="copyright">
          <span>深圳益华通盛能源动力科技有限公司版权所有</span>
          <span>粤ICP备2025367544号-1</span>
          <span>服务名称：益华通盛能源动力科技</span>
        </div>
      </div>
    </el-container>
  </div>
</template>

<script>
export default {
  data() {
    return {
      defaultActive: "/",
      isShowFooter: true,
      mobileMenuVisible: false,
      menuItems: [
        { path: "/", label: "首页" },
        { path: "/product", label: "产品介绍" },
        { path: "/case", label: "产品列表" },
        { path: "/news", label: "云平台" },
        { path: "/goin", label: "走进益华通盛" },
        { path: "/download", label: "下载小程序" }
      ]
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler(to) {
        this.defaultActive = to.path;
        // 首页不显示底部footer（因为首页有独立的版权信息）
        this.isShowFooter = to.path !== "/";
        // 关闭移动端菜单
        this.mobileMenuVisible = false;
      }
    }
  },
  methods: {
    handleSelect(key) {
      this.defaultActive = key;
    },
    navigateTo(path) {
      this.$router.push(path);
      this.mobileMenuVisible = false;
    }
  }
};
</script>

<style lang="scss">
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, "Microsoft YaHei", sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 1240px;
  margin: 0 auto;
  position: relative;

  .logo {
    width: 280px;
    padding: 5px;
    margin-left: -50px;
    a {
      display: block;
    }
    img {
      width: 100%;
      line-height: 60px;
    }
  }
}

.mobile-menu-btn {
  display: none;
  font-size: 24px;
  color: #1a75bb;
  cursor: pointer;
  padding: 10px;
}

.mobile-menu {
  display: none;
  position: absolute;
  top: 60px;
  left: 0;
  width: 100%;
  background: #fff;
  z-index: 1000;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);

  .mobile-menu-item {
    padding: 15px 20px;
    border-bottom: 1px solid #f0f0f0;
    font-size: 16px;
    color: #333;
    cursor: pointer;
    transition: all 0.3s ease;

    &:hover,
    &.active {
      background: #1a75bb;
      color: #fff;
    }
  }
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: all 0.3s ease;
}
.slide-down-enter,
.slide-down-leave-to {
  opacity: 0;
  transform: translateY(-10px);
}

.el-main {
  padding: 0 !important;
  overflow-x: hidden;
}

.footer {
  width: 100%;
  min-height: 216px;
  overflow: hidden;
  background-color: #14679f;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;

    .content-nav {
      display: flex;
      justify-content: space-around;
      flex: 1;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        align-items: flex-start;
        list-style: none;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
          font-weight: 600;
        }

        span,
        a {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
          font-size: 14px;
          text-decoration: none;
          transition: color 0.3s ease;
        }

        a:hover {
          color: #fff;
          text-decoration: underline;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
    }
  }

  .copyright {
    height: 30px;
    background: #125688;
    text-align: center;

    span {
      color: #fff;
      line-height: 30px;
      font-size: 12px;
      margin: 0 10px;
    }
  }
}

/* 响应式设计 */
@media (max-width: 1240px) {
  .el-header {
    width: 100%;
    padding: 0 20px;
  }

  .footer-content {
    width: 100% !important;
    padding: 20px !important;
  }
}

@media (max-width: 992px) {
  .footer-content {
    flex-wrap: wrap;
    justify-content: center !important;

    .content-nav {
      flex-wrap: wrap;
      justify-content: flex-start !important;

      li {
        width: 50%;
        margin-bottom: 15px;
      }
    }

    img {
      width: 120px !important;
      height: 120px !important;
    }
  }

  .el-header .logo {
    margin-left: 0;
  }
}

@media (max-width: 768px) {
  .el-header {
    .el-menu-demo {
      display: none;
    }
  }

  .mobile-menu-btn {
    display: block;
  }

  .mobile-menu {
    display: block;
  }

  .footer {
    .copyright span {
      display: block;
      line-height: 20px;
    }
    .copyright {
      height: auto;
      padding: 5px 0;
    }
  }
}

@media (max-width: 576px) {
  .footer-content {
    .content-nav li {
      width: 100%;
      padding: 0 10px;
    }

    img {
      display: none;
    }
  }
}
</style>
